import React from 'react'
import { Helmet } from 'react-helmet'
import '../style/freeResouce.css'
import fr1 from '../images/fr-1.png'
import fr2 from '../images/fr-2.png'
import fr3 from '../images/fr-3.png'

const FreeResource = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name='description' content='Umang Ratani business consultancy resources offer expert insights and tools to optimize your business growth and management strategies effectively.' />
                <title>Umang Ratani: Expert Business Consultancy Resources</title>
            </Helmet>
            <section id='bgServeNewV'>
                <div className="container" style={{ textAlign: 'center' }} >
                    <h3 id='animath5' style={{ color: "white", paddingTop: "125px", paddingBottom: '175px' }} className="block-sub__title">Free Resources</h3>
                </div>
            </section>
            <div className='container' style={{ marginTop: '50px' }}>
                <div className='row' style={{ borderStyle: 'solid', borderColor: '#DEDEDE', borderWidth: '2px 1px 2px 2px', padding: "50px" }} id='rowF'>
                    <div className='col-sm-8'>
                        <div className='row' >
                            <div className='col-sm-4'>
                                <img src={fr1} width={'225px'} height={'220px'} alt="book" />
                            </div>
                            <div className='col-sm-8'>
                                <h3>Free NLP Book</h3>
                                <p style={{ fontSize: '17px', marginTop: '17px' }}>Neuro-Linguistic Programming (NLP) is the key to unlock your true potential. Use the NLP – Success Starter Kit to understand your personal ‘Mind Map’. Apply the techniques to model and replicate successful skills.</p>
                                <p style={{ fontSize: '17px', marginTop: '10px' }}>Learn the hacks for success in your personal, professional or social life. Build confidence and shatter all fears.</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-4' style={{ textAlign: 'center', }}>
                        <img style={{ marginTop: '50px', marginLeft: '25px' }} src="https://cdn.pixabay.com/photo/2021/04/06/09/09/download-6155763_1280.png" width={'100px'} height={'100px'} alt="download" />
                    </div>
                </div>
                <div className='row' style={{ borderStyle: 'solid', borderColor: '#DEDEDE', borderWidth: '2px 1px 2px 2px', padding: "50px" }}>
                    <div className='col-sm-8'>
                        <div className='row' >
                            <div className='col-sm-4'>
                                <img src={fr2} width={'225px'} height={'290px'} alt="book" />
                            </div>
                            <div className='col-sm-8'>
                                <h3>Free Goal Setting Book</h3>
                                <h4 style={{ marginTop: '5px' }}>tep by step blueprint for setting and achieving the goals – Based on NLP</h4>
                                <p style={{ fontSize: '17px', marginTop: '5px' }}>Achieve your goals with a quick guide to goal setting. V2MOM is a proven process to visualize goals and chalk the path to get them. The V2MOM Goal Setting is a simple yet effective way to get your desired results.</p>
                                <p style={{ fontSize: '17px', marginTop: '5px' }}>Personalize the templates easily to fit your needs. The V2MOM Goal Setting is a must-have for any professional, entrepreneur, or achiever.</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-4' style={{ textAlign: 'center', }}>
                        <img style={{ marginTop: '50px', marginLeft: '25px' }} src="https://cdn.pixabay.com/photo/2021/04/06/09/09/download-6155763_1280.png" width={'100px'} height={'100px'} alt="download" />
                    </div>
                </div>
                <div className='row' style={{ borderStyle: 'solid', borderColor: '#DEDEDE', borderWidth: '2px 1px 2px 2px', padding: "50px" }}>
                    <div className='col-sm-8'>
                        <div className='row' >
                            <div className='col-sm-4'>
                                <img src={fr3} width={'225px'} height={'215px'} alt="book" />
                            </div>
                            <div className='col-sm-8'>
                                <h3>CA – Inter Audit Resources</h3>
                                <h3 style={{ marginTop: '17px' }}>The file here contains:</h3>
                                <p style={{ fontSize: '17px', marginTop: '10px' }}>List of important questions | List of priority chapter | List of good questions | List of all case study and practical questions from study material | List of all important definitions and words | CARO 16 chart | Guidance on how to prepare subject | Color chart book | Everything that you need to score exemption in audit</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-4' style={{ textAlign: 'center', }}>
                        <img style={{ marginTop: '50px', marginLeft: '25px' }} src="https://cdn.pixabay.com/photo/2021/04/06/09/09/download-6155763_1280.png" width={'100px'} height={'100px'} alt="download" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default FreeResource
